export default {
  loading: (state) => state.loading,
  kiosks: (state) => state.kiosks,
};
